import { rc } from "./rc";

export const employee_voice_multi_company_single_topic_trend = {
  rc,
};
